// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file configuracion_monitoreo.proto (package sextante.configuracion.monitoreo.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file configuracion_monitoreo.proto.
 */
export const file_configuracion_monitoreo: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Plaga que se monitorea para un cultivo en una finca.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaItem
 */
export type MonitoreoRelacionFincaCultivoPlagaItem = Message<"sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * @generated from field: string finca_id = 4;
   */
  fincaId: string;

  /**
   * @generated from field: string cultivo_id = 5;
   */
  cultivoId: string;

  /**
   * @generated from field: string plaga_enfermedad_id = 6;
   */
  plagaEnfermedadId: string;

  /**
   * Unico campo denormalizado que se transporta: lo usa el store local como campo de orden
   * (DatabaseListResponseBase.sort); cultivoNombre/plagaEnfermedadNombreTecnico no los lee nadie
   * en el Cliente y se dejan fuera. Ver CLAUDE.md.
   *
   * @generated from field: string plaga_enfermedad_nombre_comun = 7;
   */
  plagaEnfermedadNombreComun: string;

  /**
   * --- Valores de referencia del cliente (especificacion v1.0, seccion 3.2 C) ---
   * Ausente significa "usa el valor por defecto del cultivo", NO "sin umbral": son dos cosas
   * distintas y confundirlas apagaria el semaforo de ese organismo.
   *
   * @generated from field: optional double nivel_bajo_max = 8;
   */
  nivelBajoMax?: number | undefined;

  /**
   * @generated from field: optional double nivel_medio_max = 9;
   */
  nivelMedioMax?: number | undefined;

  /**
   * % de arboles
   *
   * @generated from field: optional double incidencia_bajo_max = 10;
   */
  incidenciaBajoMax?: number | undefined;

  /**
   * % de arboles
   *
   * @generated from field: optional double incidencia_medio_max = 11;
   */
  incidenciaMedioMax?: number | undefined;

  /**
   * Sube en cada cambio de valores. Se congela en cada sesion junto con los valores, asi que un
   * informe viejo sigue diciendo con que umbrales se evaluo.
   *
   * @generated from field: int32 referencia_version = 12;
   */
  referenciaVersion: number;

  /**
   * Quien cambio los valores y cuando (Unix ms). Van aparte de ultima_actualizacion, que cambia
   * tambien al activar o desactivar el organismo.
   *
   * @generated from field: optional string referencia_modificado_por = 13;
   */
  referenciaModificadoPor?: string | undefined;

  /**
   * @generated from field: optional int64 referencia_modificado_en = 14;
   */
  referenciaModificadoEn?: bigint | undefined;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaItem.
 * Use `create(MonitoreoRelacionFincaCultivoPlagaItemSchema)` to create a new message.
 */
export const MonitoreoRelacionFincaCultivoPlagaItemSchema: GenMessage<MonitoreoRelacionFincaCultivoPlagaItem> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 0);

/**
 * Ajuste de los valores de referencia de un organismo en una finca.
 * 
 * Un campo ausente NO es "no tocar": es "volver al valor por defecto del cultivo". El pedido lleva
 * siempre los cuatro, que es como los muestra la pantalla.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.GuardarMonitoreoReferenciaRequest
 */
export type GuardarMonitoreoReferenciaRequest = Message<"sextante.configuracion.monitoreo.v1.GuardarMonitoreoReferenciaRequest"> & {
  /**
   * @generated from field: string relacion_id = 1;
   */
  relacionId: string;

  /**
   * @generated from field: optional double nivel_bajo_max = 2;
   */
  nivelBajoMax?: number | undefined;

  /**
   * @generated from field: optional double nivel_medio_max = 3;
   */
  nivelMedioMax?: number | undefined;

  /**
   * @generated from field: optional double incidencia_bajo_max = 4;
   */
  incidenciaBajoMax?: number | undefined;

  /**
   * @generated from field: optional double incidencia_medio_max = 5;
   */
  incidenciaMedioMax?: number | undefined;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.GuardarMonitoreoReferenciaRequest.
 * Use `create(GuardarMonitoreoReferenciaRequestSchema)` to create a new message.
 */
export const GuardarMonitoreoReferenciaRequestSchema: GenMessage<GuardarMonitoreoReferenciaRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 1);

/**
 * Pedido del historial de valores de un organismo.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.ListarMonitoreoHistorialReferenciaRequest
 */
export type ListarMonitoreoHistorialReferenciaRequest = Message<"sextante.configuracion.monitoreo.v1.ListarMonitoreoHistorialReferenciaRequest"> & {
  /**
   * @generated from field: string relacion_id = 1;
   */
  relacionId: string;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.ListarMonitoreoHistorialReferenciaRequest.
 * Use `create(ListarMonitoreoHistorialReferenciaRequestSchema)` to create a new message.
 */
export const ListarMonitoreoHistorialReferenciaRequestSchema: GenMessage<ListarMonitoreoHistorialReferenciaRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 2);

/**
 * Una version anterior de los valores.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.MonitoreoReferenciaHistorialItem
 */
export type MonitoreoReferenciaHistorialItem = Message<"sextante.configuracion.monitoreo.v1.MonitoreoReferenciaHistorialItem"> & {
  /**
   * @generated from field: int32 version = 1;
   */
  version: number;

  /**
   * @generated from field: optional double nivel_bajo_max = 2;
   */
  nivelBajoMax?: number | undefined;

  /**
   * @generated from field: optional double nivel_medio_max = 3;
   */
  nivelMedioMax?: number | undefined;

  /**
   * @generated from field: optional double incidencia_bajo_max = 4;
   */
  incidenciaBajoMax?: number | undefined;

  /**
   * @generated from field: optional double incidencia_medio_max = 5;
   */
  incidenciaMedioMax?: number | undefined;

  /**
   * @generated from field: optional string modificado_por = 6;
   */
  modificadoPor?: string | undefined;

  /**
   * Cuando se dejo atras esta version, en Unix ms.
   *
   * @generated from field: int64 modificado_en = 7;
   */
  modificadoEn: bigint;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.MonitoreoReferenciaHistorialItem.
 * Use `create(MonitoreoReferenciaHistorialItemSchema)` to create a new message.
 */
export const MonitoreoReferenciaHistorialItemSchema: GenMessage<MonitoreoReferenciaHistorialItem> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 3);

/**
 * Versiones anteriores, de la mas nueva a la mas vieja.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.ListarMonitoreoHistorialReferenciaResponse
 */
export type ListarMonitoreoHistorialReferenciaResponse = Message<"sextante.configuracion.monitoreo.v1.ListarMonitoreoHistorialReferenciaResponse"> & {
  /**
   * @generated from field: repeated sextante.configuracion.monitoreo.v1.MonitoreoReferenciaHistorialItem items = 1;
   */
  items: MonitoreoReferenciaHistorialItem[];
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.ListarMonitoreoHistorialReferenciaResponse.
 * Use `create(ListarMonitoreoHistorialReferenciaResponseSchema)` to create a new message.
 */
export const ListarMonitoreoHistorialReferenciaResponseSchema: GenMessage<ListarMonitoreoHistorialReferenciaResponse> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 4);

/**
 * Pedido de las plagas configuradas en una finca.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.ListMonitoreoRelacionesByFincaIdRequest
 */
export type ListMonitoreoRelacionesByFincaIdRequest = Message<"sextante.configuracion.monitoreo.v1.ListMonitoreoRelacionesByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.ListMonitoreoRelacionesByFincaIdRequest.
 * Use `create(ListMonitoreoRelacionesByFincaIdRequestSchema)` to create a new message.
 */
export const ListMonitoreoRelacionesByFincaIdRequestSchema: GenMessage<ListMonitoreoRelacionesByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 5);

/**
 * Configuraciones que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.ListMonitoreoRelacionesByFincaIdResponse
 */
export type ListMonitoreoRelacionesByFincaIdResponse = Message<"sextante.configuracion.monitoreo.v1.ListMonitoreoRelacionesByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaItem items = 1;
   */
  items: MonitoreoRelacionFincaCultivoPlagaItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.ListMonitoreoRelacionesByFincaIdResponse.
 * Use `create(ListMonitoreoRelacionesByFincaIdResponseSchema)` to create a new message.
 */
export const ListMonitoreoRelacionesByFincaIdResponseSchema: GenMessage<ListMonitoreoRelacionesByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 6);

/**
 * Plaga a agregar para un cultivo de la finca.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.GuardarMonitoreoRelacionRequest
 */
export type GuardarMonitoreoRelacionRequest = Message<"sextante.configuracion.monitoreo.v1.GuardarMonitoreoRelacionRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * @generated from field: string cultivo_id = 2;
   */
  cultivoId: string;

  /**
   * @generated from field: string plaga_enfermedad_id = 3;
   */
  plagaEnfermedadId: string;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.GuardarMonitoreoRelacionRequest.
 * Use `create(GuardarMonitoreoRelacionRequestSchema)` to create a new message.
 */
export const GuardarMonitoreoRelacionRequestSchema: GenMessage<GuardarMonitoreoRelacionRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 7);

/**
 * Configuracion a quitar.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.EliminarMonitoreoRelacionRequest
 */
export type EliminarMonitoreoRelacionRequest = Message<"sextante.configuracion.monitoreo.v1.EliminarMonitoreoRelacionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.EliminarMonitoreoRelacionRequest.
 * Use `create(EliminarMonitoreoRelacionRequestSchema)` to create a new message.
 */
export const EliminarMonitoreoRelacionRequestSchema: GenMessage<EliminarMonitoreoRelacionRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 8);

/**
 * Sin datos: que el rpc no falle ya indica que se quito.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.EliminarMonitoreoRelacionResponse
 */
export type EliminarMonitoreoRelacionResponse = Message<"sextante.configuracion.monitoreo.v1.EliminarMonitoreoRelacionResponse"> & {
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.EliminarMonitoreoRelacionResponse.
 * Use `create(EliminarMonitoreoRelacionResponseSchema)` to create a new message.
 */
export const EliminarMonitoreoRelacionResponseSchema: GenMessage<EliminarMonitoreoRelacionResponse> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 9);

/**
 * Usuario monitor de MonitoreoApp.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.MonitoreoUsuarioItem
 */
export type MonitoreoUsuarioItem = Message<"sextante.configuracion.monitoreo.v1.MonitoreoUsuarioItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * @generated from field: string cliente_id = 4;
   */
  clienteId: string;

  /**
   * @generated from field: string nombre = 5;
   */
  nombre: string;

  /**
   * @generated from field: string email = 6;
   */
  email: string;

  /**
   * PIN con el que el monitor entra a MonitoreoApp.
   *
   * @generated from field: string pin = 7;
   */
  pin: string;

  /**
   * Ultima vez que el monitor entro a MonitoreoApp, si alguna vez entro.
   *
   * @generated from field: optional string ultimo_ingreso = 8;
   */
  ultimoIngreso?: string | undefined;

  /**
   * false si esta inactivo: no puede entrar a MonitoreoApp.
   *
   * @generated from field: bool is_activo = 9;
   */
  isActivo: boolean;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.MonitoreoUsuarioItem.
 * Use `create(MonitoreoUsuarioItemSchema)` to create a new message.
 */
export const MonitoreoUsuarioItemSchema: GenMessage<MonitoreoUsuarioItem> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 10);

/**
 * Pedido de los monitores de un cliente.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.ListMonitoreoUsuariosByClienteIdRequest
 */
export type ListMonitoreoUsuariosByClienteIdRequest = Message<"sextante.configuracion.monitoreo.v1.ListMonitoreoUsuariosByClienteIdRequest"> & {
  /**
   * @generated from field: string cliente_id = 1;
   */
  clienteId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.ListMonitoreoUsuariosByClienteIdRequest.
 * Use `create(ListMonitoreoUsuariosByClienteIdRequestSchema)` to create a new message.
 */
export const ListMonitoreoUsuariosByClienteIdRequestSchema: GenMessage<ListMonitoreoUsuariosByClienteIdRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 11);

/**
 * Monitores que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.ListMonitoreoUsuariosByClienteIdResponse
 */
export type ListMonitoreoUsuariosByClienteIdResponse = Message<"sextante.configuracion.monitoreo.v1.ListMonitoreoUsuariosByClienteIdResponse"> & {
  /**
   * @generated from field: repeated sextante.configuracion.monitoreo.v1.MonitoreoUsuarioItem items = 1;
   */
  items: MonitoreoUsuarioItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.ListMonitoreoUsuariosByClienteIdResponse.
 * Use `create(ListMonitoreoUsuariosByClienteIdResponseSchema)` to create a new message.
 */
export const ListMonitoreoUsuariosByClienteIdResponseSchema: GenMessage<ListMonitoreoUsuariosByClienteIdResponse> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 12);

/**
 * Datos de un monitor a crear o editar.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.GuardarMonitoreoUsuarioRequest
 */
export type GuardarMonitoreoUsuarioRequest = Message<"sextante.configuracion.monitoreo.v1.GuardarMonitoreoUsuarioRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.GuardarMonitoreoUsuarioRequest.
 * Use `create(GuardarMonitoreoUsuarioRequestSchema)` to create a new message.
 */
export const GuardarMonitoreoUsuarioRequestSchema: GenMessage<GuardarMonitoreoUsuarioRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 13);

/**
 * Monitor sobre el que se actua.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.MonitoreoUsuarioIdRequest
 */
export type MonitoreoUsuarioIdRequest = Message<"sextante.configuracion.monitoreo.v1.MonitoreoUsuarioIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.MonitoreoUsuarioIdRequest.
 * Use `create(MonitoreoUsuarioIdRequestSchema)` to create a new message.
 */
export const MonitoreoUsuarioIdRequestSchema: GenMessage<MonitoreoUsuarioIdRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 14);

/**
 * Sin datos: que el rpc no falle ya indica que se mando el correo.
 *
 * @generated from message sextante.configuracion.monitoreo.v1.ReenviarCredencialesResponse
 */
export type ReenviarCredencialesResponse = Message<"sextante.configuracion.monitoreo.v1.ReenviarCredencialesResponse"> & {
};

/**
 * Describes the message sextante.configuracion.monitoreo.v1.ReenviarCredencialesResponse.
 * Use `create(ReenviarCredencialesResponseSchema)` to create a new message.
 */
export const ReenviarCredencialesResponseSchema: GenMessage<ReenviarCredencialesResponse> = /*@__PURE__*/
  messageDesc(file_configuracion_monitoreo, 15);

/**
 * Plagas a monitorear por cultivo en una finca.
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaService
 */
export const MonitoreoRelacionFincaCultivoPlagaService: GenService<{
  /**
   * Plagas configuradas en una finca, por delta.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaService.ListByFincaId
   */
  listByFincaId: {
    methodKind: "unary";
    input: typeof ListMonitoreoRelacionesByFincaIdRequestSchema;
    output: typeof ListMonitoreoRelacionesByFincaIdResponseSchema;
  },
  /**
   * Agrega una plaga a monitorear para un cultivo de la finca.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarMonitoreoRelacionRequestSchema;
    output: typeof MonitoreoRelacionFincaCultivoPlagaItemSchema;
  },
  /**
   * Quita una plaga de la configuracion de la finca.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof EliminarMonitoreoRelacionRequestSchema;
    output: typeof EliminarMonitoreoRelacionResponseSchema;
  },
  /**
   * Ajusta los valores de referencia de un organismo en una finca. Sube la version y deja la version
   * anterior en el historial. Mandar un campo en nulo = volver al valor por defecto del cultivo.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaService.GuardarReferencia
   */
  guardarReferencia: {
    methodKind: "unary";
    input: typeof GuardarMonitoreoReferenciaRequestSchema;
    output: typeof MonitoreoRelacionFincaCultivoPlagaItemSchema;
  },
  /**
   * Versiones anteriores de los valores de un organismo, de la mas nueva a la mas vieja.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoRelacionFincaCultivoPlagaService.ListarHistorialReferencia
   */
  listarHistorialReferencia: {
    methodKind: "unary";
    input: typeof ListarMonitoreoHistorialReferenciaRequestSchema;
    output: typeof ListarMonitoreoHistorialReferenciaResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_configuracion_monitoreo, 0);

/**
 * Usuarios monitores de un cliente: entran a MonitoreoApp con su email y un PIN.
 * 
 * Pertenencia (2026-09-30): el cliente_id del pedido tiene que ser el de la sesion, y solo se tocan registros
 * de ese cliente. Otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.configuracion.monitoreo.v1.MonitoreoUsuarioService
 */
export const MonitoreoUsuarioService: GenService<{
  /**
   * Monitores de un cliente, por delta.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoUsuarioService.ListByClienteId
   */
  listByClienteId: {
    methodKind: "unary";
    input: typeof ListMonitoreoUsuariosByClienteIdRequestSchema;
    output: typeof ListMonitoreoUsuariosByClienteIdResponseSchema;
  },
  /**
   * Crea el monitor si no viene id, o lo edita si viene. Al crearlo o al cambiarle el email genera un PIN
   * nuevo y le manda las credenciales por correo. El email no se puede repetir entre los monitores del
   * cliente.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoUsuarioService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarMonitoreoUsuarioRequestSchema;
    output: typeof MonitoreoUsuarioItemSchema;
  },
  /**
   * Activa un monitor: vuelve a poder entrar a MonitoreoApp.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoUsuarioService.Activar
   */
  activar: {
    methodKind: "unary";
    input: typeof MonitoreoUsuarioIdRequestSchema;
    output: typeof MonitoreoUsuarioItemSchema;
  },
  /**
   * Inactiva un monitor: corta sus sesiones y no puede volver a entrar hasta que se active.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoUsuarioService.Inactivar
   */
  inactivar: {
    methodKind: "unary";
    input: typeof MonitoreoUsuarioIdRequestSchema;
    output: typeof MonitoreoUsuarioItemSchema;
  },
  /**
   * Vuelve a mandar al monitor el correo con su email y PIN.
   *
   * @generated from rpc sextante.configuracion.monitoreo.v1.MonitoreoUsuarioService.ReenviarCredenciales
   */
  reenviarCredenciales: {
    methodKind: "unary";
    input: typeof MonitoreoUsuarioIdRequestSchema;
    output: typeof ReenviarCredencialesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_configuracion_monitoreo, 1);

